import { Outlet } from "react-router-dom";
import { AppShell } from "./AppShell";
import { FeedbackButton } from "./FeedbackButton";
import { KbdShortcuts, useGlobalGotoShortcuts } from "./KbdShortcuts";

/**
 * Wraps every authed route. v0.4.0 additions: mounts the global keyboard
 * shortcut overlay and registers the g+letter go-to shortcuts so they work
 * on every page reachable from the shell.
 */
export function AppShellLayout() {
  useGlobalGotoShortcuts();
  return (
    <AppShell>
      <Outlet />
      <FeedbackButton />
      <KbdShortcuts />
    </AppShell>
  );
}
